// DashPeriodFilter — 6 pill buttons for period selection
// Extracted from AdminIATab.tsx

interface DashPeriodFilterProps {
  value: string;
  onChange: (p: string) => void;
}

const PERIODS = [
  { key: 'este_mes', label: 'Este mes' },
  { key: 'mes_anterior', label: 'Mes anterior' },
  { key: '7_dias', label: '7 dias' },
  { key: '30_dias', label: '30 dias' },
  { key: '90_dias', label: '90 dias' },
  { key: 'todo', label: 'Todo' },
];

export function DashPeriodFilter({ value, onChange }: DashPeriodFilterProps) {
  return (
    <div style={{ display: 'flex', gap: 6, marginBottom: 14 }}>
      {PERIODS.map((p) => (
        <button
          key={p.key}
          onClick={() => onChange(p.key)}
          style={{
            padding: '6px 14px',
            borderRadius: 20,
            border: 'none',
            fontSize: 11,
            fontWeight: value === p.key ? 600 : 400,
            cursor: 'pointer',
            fontFamily: 'inherit',
            background: value === p.key ? '#1F3864' : '#F2F2F2',
            color: value === p.key ? '#fff' : '#595959',
            transition: 'all 0.2s ease',
          }}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
